import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-skeleton-list-card',
  templateUrl: './skeleton-list-card.component.html',
  styleUrls: ['./skeleton-list-card.component.scss']
})
export class SkeletonListCardComponent implements OnInit {
@Input() userType!: string;
  constructor() { }

  ngOnInit() {
  }

}
